import React from 'react'
import { VerticalDots } from '../../../assets'

export const MCProductNameComponent = (props) => {
  const { value, data } = props

  const verticalImageClick = (e) => {
    props.menuEvent(e, props.data)
  }

  const numChildren = data.children && data.children.length
  const isParent = !!data.children
  return (
    <div className="container-category-name">
      <img
        className="vertical-dots"
        src={`${VerticalDots}`}
        onClick={(e) => verticalImageClick(e)}
      />
      {value}{' '}
      {isParent ? (
        <span style={{ fontWeight: 'bold', marginLeft: '4px' }}>({numChildren})</span>
      ) : null}
    </div>
  )
}

export default MCProductNameComponent



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/Components/MCProductNameComponent.js